const VIDEO_OVERLAY_PLAYBACK_PARAMS = [
  'autoplay',
  'mute',
  'playsinline',
  'origin',
  'enablejsapi',
  'widgetid',
  'widget_referrer',
  'feature',
];

/**
 * Normalize a video source URL for comparison by stripping overlay playback params.
 *
 * @since ??
 *
 * @param {string} url The video source URL.
 *
 * @returns {string} Normalized URL for source comparison.
 */
export const normalizeVideoSource = (url: string): string => {
  if ('' === url) {
    return '';
  }

  try {
    const parsed = new URL(url, window.location.origin);

    VIDEO_OVERLAY_PLAYBACK_PARAMS.forEach(param => {
      parsed.searchParams.delete(param);
    });

    return `${parsed.origin}${parsed.pathname}${parsed.search}`;
  } catch {
    return url
      .replace(/([?&])(autoplay|mute|playsinline|origin|enablejsapi|widgetid|widget_referrer|feature)=[^&]*/g, '')
      .replace(/[?&]$/, '');
  }
};
